// A blank password would replace the saved one, so the field is sent only once the user types it.
export function withoutBlankPassword<T> ( settings : T, field : keyof T ) : Partial<T> {
  if ( settings[field] ) {
    return settings;
  }

  const payload : Partial<T> = { ...settings };

  delete payload[field];

  return payload;
}
